module.exports = __webpack_public_path__ + "static/media/3 Como comprar-min.73f40d4e.jpg";